import React, { useState } from "react";
import { toast } from "react-toastify";

declare global {
  interface Window {
    grecaptcha: any;
  }
}

interface ContactFormState {
  firstName: string;
  lastName: string;
  email: string;
  objet: string;
  phone: string;
  message: string;
}

export default function ContactPage() {
  const [form, setForm] = useState<ContactFormState>({
    firstName: "",
    lastName: "",
    objet: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!window.grecaptcha || !window.grecaptcha.execute) {
      alert(
        toast.error(
          "reCAPTCHA n'est pas prêt. Veuillez réessayer dans quelques secondes."
        )
      );
      return;
    }

    try {
      const captchaToken = await window.grecaptcha.execute(
        "6Lf6u24rAAAAAJl1Njwz9ieD9kjXYnGc1VcPGSSa",
        { action: "contact" }
      );

      if (!captchaToken) {
        alert("Échec de génération du token reCAPTCHA");
        return;
      }

      const API_BASE_URL = process.env.REACT_APP_API_URL;

      const response = await fetch(`${API_BASE_URL}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          captchaToken,
        }),
      });

      if (response.ok) {
        toast.info("Votre message a bien été envoyé !");
        setForm({
          firstName: "",
          lastName: "",
          objet: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        toast.error("Erreur lors de l’envoi du formulaire");
      }
    } catch (error) {
      toast.error("Erreur lors de l’envoi du formulaire");
    }
  };

  return (
    <div className="flex items-center justify-center py-4 px-4 sm:px-6 lg:px-8 min-h-screen ">
      <div className="w-full max-w-2xl bg-white p-6 sm:p-10 rounded-lg">
        <h2 className="text-3xl font-bold text-gray-900 text-start mb-4">
          Contactez-nous
        </h2>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Prénom
              </label>
              <input
                type="text"
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-2 border border-gray-300 placeholder:text-gray-400 sm:text-sm"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Nom
              </label>
              <input
                type="text"
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-2 border border-gray-300 placeholder:text-gray-400 sm:text-sm"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Objet
            </label>
            <input
              type="text"
              name="objet"
              value={form.objet}
              onChange={handleChange}
              className="block w-full rounded-md bg-white px-3 py-2 border border-gray-300 placeholder:text-gray-400 sm:text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Adresse e-mail
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="block w-full rounded-md bg-white px-3 py-2 border border-gray-300 placeholder:text-gray-400 sm:text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Numéro de téléphone
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              className="block w-full rounded-md bg-white px-3 py-2 border border-gray-300 placeholder:text-gray-400 sm:text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Message
            </label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              rows={4}
              className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 sm:text-sm"
              required
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Envoyer le message
          </button>
        </form>
      </div>
    </div>
  );
}
